// How to get a login for each executor that can be connected with a pasted
// token (Executors page, for an existing Claude Code or Codex connection,
// and the first-login welcome). A ChatGPT subscription (`pi_login`) only
// ever signs in through the "Sign in with ChatGPT" flow, so it has no entry
// here.

export const TOKEN_HELP: Record<
  string,
  { label: string; how: string; placeholder: string }
> = {
  claude_cli: {
    label: 'Claude token',
    how: 'Run `claude setup-token` on a machine where you’re logged in to Claude and paste the token it prints. An Anthropic API key works too.',
    placeholder: 'sk-ant-oat01-… or sk-ant-api03-…',
  },
  codex_cli: {
    label: 'Codex login',
    how: 'For a ChatGPT subscription: run `export CODEX_HOME=$(mktemp -d) && codex login && cat $CODEX_HOME/auth.json` on a machine with a browser, choose “Sign in with ChatGPT”, and paste what it prints. A separate login, so Goblic and your own Codex don’t sign each other out. An OpenAI API key (platform.openai.com → API keys) works too.',
    placeholder: '{"auth_mode":"chatgpt",…} or sk-…',
  },
}
